import { useSelector } from "react-redux";
import { useEffect } from "react";
import { getCollabImagesState } from "./funtions";
export function useCollabImagesSync(excalidrawAPI) {
    const collabImagesState = useSelector(getCollabImagesState);
    const syncImages = async () => {
        const imagesMetadata = Array.from(collabImagesState.images.values());
        const existingFiles = excalidrawAPI.getFiles();
        imagesMetadata.map((image) => {
            if (!existingFiles[image.id] || existingFiles[image.id].dataURL == null) {
                try {
                    excalidrawAPI.addFiles([{
                            id: image.id,
                            mimeType: image.mimetype,
                            dataURL: image.dataURL,
                            created: new Date(image.createdAt).getTime()
                        }]);
                }
                catch (error) {
                    console.error('Error syncing image:', image.id, error);
                }
            }
        });
        excalidrawAPI.updateScene({
            elements: excalidrawAPI.getSceneElementsIncludingDeleted()
        });
    };
    useEffect(() => {
        syncImages();
    }, [collabImagesState.images, excalidrawAPI]);
    return { syncImages };
}
